import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
    createApiKey,
    deleteApiKey,
    fetchApiKeys,
    renameApiKey,
} from '../api/apiKeys.api';

const API_KEYS_KEY = 'api-keys';

export const useApiKeys = (options = {}) =>
    useQuery(API_KEYS_KEY, fetchApiKeys, options);

export const useGenerateApiKey = () => {
    const qc = useQueryClient();
    return useMutation(createApiKey, {
        onSuccess: () => qc.invalidateQueries(API_KEYS_KEY),
    });
};

export const useRenameApiKey = () => {
    const qc = useQueryClient();
    return useMutation(({ keyId, name }) => renameApiKey(keyId, name), {
        onSuccess: () => qc.invalidateQueries(API_KEYS_KEY),
    });
};

export const useRevokeApiKey = () => {
    const qc = useQueryClient();
    return useMutation(deleteApiKey, {
        onSuccess: () => qc.invalidateQueries(API_KEYS_KEY),
    });
};
